<!-- 关键特征 -->
<template>
  <div class="home">
    <!-- Header -->
    <Header @openForm="openForm" :isPageScroll="isPageScroll" :headColor="headColor" :router="'Product'"></Header>
    <!-- banner -->
    <div class="banner">
      <div class="banner-div">
        <div class="banner-title">数字化转型一站式解决方案</div>
        <div class="banner-desc">
          轻骑兵低代码PaaS平台是专为中大型企业打造的企业级解决方案平台，集成了人工智能、微服务、低代码等先进技术。
          平台结合金现代多年来在企业级技术服务领域的深厚积累，如低代码开发平台、零代码开发平台、融合集成平台、工作流平台和统一门户平台等，为企
          业提供了全方位、多场景、多层次的数字化支持。平台支持根据客户的特殊需求进行高度个性化的定制，每个产品拥有其独特价值，无论是独立使用还是
          组合使用，轻骑兵PaaS平台都能根据客户的规模、IT规划和应用场景的不同，灵活授权，以满足企业的多样化需求。
        </div>
      </div>
    </div>
    <div class="content">
      <div id="navigation-div" class="navigation-div">
        <div class="nav-level1" @click="clickRolling('level1')">
          <img src="../assets/img/allProduct/div1.png">
          快速开发能力
        </div>
        <div class="nav-level2">
          <span @click="clickRolling('level1-1')">零代码开发</span><br>
          <span @click="clickRolling('level1-2')">低代码开发</span>
        </div>
        <div class="nav-level1" @click="clickRolling('level2')">
          <img src="../assets/img/allProduct/div2.png">
          通用能力
        </div>
        <div class="nav-level2">
          <span @click="clickRolling('level2-1')">融合集成平台</span><br>
          <span @click="clickRolling('level2-2')">统一门户平台</span><br>
          <span @click="clickRolling('level2-3')">工作流平台</span>
        </div>
        <div class="nav-level1" @click="clickRolling('level3')">
          <img src="../assets/img/allProduct/div3.png">
          智能服务
        </div>
        <div class="nav-level2">
          <span @click="clickRolling('level3-1')">OCR能力平台</span><br>
          <span @click="clickRolling('level3-2')">智能问答</span><br>
          <span @click="clickRolling('level3-3')">知识图谱引擎</span><br>
          <span @click="clickRolling('level3-4')">低代码专有大模型</span>
        </div>
        <div class="nav-level1" @click="clickRolling('level4')">
          <img src="../assets/img/allProduct/div4.png">
          关键特性
        </div>
        <div class="nav-level1" @click="clickRolling('level5')">
          <img src="../assets/img/allProduct/div5.png">
          支撑体系
        </div>
      </div>
      <div id="content-div" class="content-div">
        <div class="content-title1" id="level1">
          <img src="../assets/img/allProduct/div1.png">
          快速开发能力
        </div>
        <div class="content-title2" id="level1-1">
          零代码开发
        </div>
        <div class="content-div2">
          <div class="content-div3">
            <div class="content-title3">表单设计器<img src="../assets/img/allProduct/hot-img.png"></div>
            <div class="content-desc3">通过可视化拖拽与快速配置的方式快速搭建应用系统，一次开发多端适配。</div>
          </div>
          <div class="content-div3">
            <div class="content-title3">表格设计器<img src="../assets/img/allProduct/hot-img.png"></div>
            <div class="content-desc3">支持表单自动生成数据看板，为企业数据分析提供有效支撑。</div>
          </div>
          <div class="content-div3">
            <div class="content-title3">流程设计器</div>
            <div class="content-desc3">提供可视化流程建模能力，支持业务流程快速绘制，提供常用的流程操作。</div>
          </div>
        </div>
        <div class="content-div2">
          <div class="content-div3">
            <div class="content-title3">表单权限</div>
            <div class="content-desc3">通过权限设置，可以灵活控制哪些人能看到哪些数据，确保数据安全。</div>
          </div>
          <div class="content-div3">
            <div class="content-title3">仪表盘</div>
            <div class="content-desc3">通过简单的拖拽，即可制作出一个个柱形图、折线图、饼图等图表，还可以自定义颜色等信息。</div>
          </div>
          <div class="content-div3">
            <div class="content-title3">数据工厂</div>
            <div class="content-desc3">包含数据流和数据集，支持跨应用、跨表单取数据，数据筛选、数据汇总、分组合并、数据联查等功能。 </div>
          </div>
        </div>
        <div class="content-div2">
          <div class="content-div3">
            <div class="content-title3">数据权限</div>
            <div class="content-desc3">提供开发权限、应用权限、表单权限等多维度多层次的数据权限控制体系。 </div>
          </div>
          <div class="content-div3">
            <div class="content-title3">API连接</div>
            <div class="content-desc3">支持将已有API通过可视化配置的方式注册到平台上，或通过图形化编排的方式组合已有API服务开放为新的APl。</div>
          </div>
        </div>
        <div class="content-title2" id="level1-2">
          低代码开发
        </div>
        <div class="content-div2">
          <div class="content-div3">
            <div class="content-title3">Web表单设计器<img src="../assets/img/allProduct/hot-img.png"></div>
            <div class="content-desc3">通过可视化拖拽与快速配置的方式搭建Web表单，支持绝对定位和相对定位。</div>
          </div>
          <div class="content-div3">
            <div class="content-title3">移动表单设计器</div>
            <div class="content-desc3">通过可视化拖拽与快速配置的方式搭建移动端表单，适配多种移动设备。</div>
          </div>
          <div class="content-div3">
            <div class="content-title3">流程设计器</div>
            <div class="content-desc3">通过可视化拖拽与配置的方式直观建模，高效构建，灵活定制业务流程。</div>
          </div>
        </div>
        <div class="content-div2">
          <div class="content-div3">
            <div class="content-title3">模型设计器</div>
            <div class="content-desc3">支持新建和同步数据模型，简化建模，直观设计，助力数据驱动决策。</div>
          </div>
          <div class="content-div3">
            <div class="content-title3">主题设计器</div>
            <div class="content-desc3">内置多套主题，支持主题定制，呈现独特风格。</div>
          </div>
          <div class="content-div3">
            <div class="content-title3">基础服务</div>
            <div class="content-desc3">PaaS平台提供运行底座，为各个子产品提供基础服务支撑，默认提供130余项基础服务功能。 </div>
          </div>
        </div>
        <div class="content-div2">
          <div class="content-div3">
            <div class="content-title3">AI智能创建</div>
            <div class="content-desc3">提供开发权限、应用权限、表单权限等多维度多层次的数据权限控制体系。 </div>
          </div>
          <div class="content-div3">
            <div class="content-title3">高级组件</div>
            <div class="content-desc3">内置多种高级组件，功能强大，灵活配置，提升应用体验，满足多样化需求。</div>
          </div>
        </div>
        <div class="content-title1" id="level2">
          <img src="../assets/img/allProduct/div2.png">
          通用能力
        </div>
        <div class="content-title2"  id="level2-1">
          融合集成平台
        </div>
        <div class="content-div2">
          <div class="content-div3">
            <div class="content-title3">接口快速开发</div>
            <div class="content-desc3">将已有后端服务(API)通过在线可视化配置的方式注册到平台上。</div>
          </div>
          <div class="content-div3">
            <div class="content-title3">接口编排开发</div>
            <div class="content-desc3">通过图形化编排的方式组合已有API服务开放为新的APl。</div>
          </div>
          <div class="content-div3">
            <div class="content-title3">数据集成</div>
            <div class="content-desc3">支持MYSQL、达梦、Oracle、人大金仓等7种关系型数据库。</div>
          </div>
        </div>
        <div class="content-div2">
          <div class="content-div3">
            <div class="content-title3">消息集成</div>
            <div class="content-desc3">支持Kafka、RabbitMQ、MQTT等 多种消息队列。</div>
          </div>
          <div class="content-div3">
            <div class="content-title3">接口运维管理</div>
            <div class="content-desc3">记录应用接口发布日志、接口运行日志等，并对接口调用情况做出统计分析。</div>
          </div>
          <div class="content-div3">
            <div class="content-title3">资产市场</div>
            <div class="content-desc3">企业开放接口/事件的汇聚之地，提供API检索、API文档及权限控制等。 </div>
          </div>
        </div>
        <div class="content-div2">
          <div class="content-div3">
            <div class="content-title3">接口安全治理</div>
            <div class="content-desc3">提供全方位的网络安全防护，确保数据安全无忧，同时稳定保障系统运行。</div>
          </div>
        </div>
        <div class="content-title2" id="level2-2">
          统一门户平台
        </div>
        <div class="content-div2">
          <div class="content-div3">
            <div class="content-title3">智能工作台</div>
            <div class="content-desc3">提供基于拖拽配置式的可视化页面，打造千人千面、千企千面的智能工作台。</div>
          </div>
          <div class="content-div3">
            <div class="content-title3">应用中心</div>
            <div class="content-desc3">通过应用中心实现各系统入口统一。</div>
          </div>
          <div class="content-div3">
            <div class="content-title3">消息中心</div>
            <div class="content-desc3">聚合各种信息源，待办事项、消息提醒、 通知公告和日程集中展示，高效协同办公。</div>
          </div>
        </div>
        <div class="content-div2">
          <div class="content-div3">
            <div class="content-title3">消息集成</div>
            <div class="content-desc3">支持Kafka、RabbitMQ、MQTT等 多种消息队列。</div>
          </div>
          <div class="content-div3">
            <div class="content-title3">统一认证</div>
            <div class="content-desc3">提供单点登录功能，仅需一次登录就能访问所有有权限的应用。</div>
          </div>
          <div class="content-div3">
            <div class="content-title3">统一权限</div>
            <div class="content-desc3">组织、用户、权限统一管理，企业资源多维度精细化控制。 </div>
          </div>
        </div>
        <div class="content-title2" id="level2-3">
          工作流平台
        </div>
        <div class="content-div2">
          <div class="content-div3">
            <div class="content-title3">可视化建模</div>
            <div class="content-desc3">提供可视化的流程建模工具，支持采用拖拉拽的方式进行流程建模。 </div>
          </div>
          <div class="content-div3">
            <div class="content-title3">流程测试</div>
            <div class="content-desc3">支持参数配置、自动执行及流程测试结果 分析，减少流程调试时间，降低试错成本。</div>
          </div>
          <div class="content-div3">
            <div class="content-title3">流程执行</div>
            <div class="content-desc3">提供丰富的流程审批场景，支持中国式流程审批操作。</div>
          </div>
        </div>
        <div class="content-div2">
          <div class="content-div3">
            <div class="content-title3">在线调整</div>
            <div class="content-desc3">业务人员在线加签、加减节点，运维人员修改参与者、表单权限、流程配置等操作。</div>
          </div>
          <div class="content-div3">
            <div class="content-title3">流程运维</div>
            <div class="content-desc3">提供流程基础运维服务，实现核心流程运维能力，同时支持对异常流程数据进行干预操作。</div>
          </div>
          <div class="content-div3">
            <div class="content-title3">流程分析</div>
            <div class="content-desc3">支持对流程数据进行全方位的流程运行分析，全面展现流程的执行情况，为管理者提供决策依据和流程优化支持。</div>
          </div>
        </div>
        <div class="content-div2">
          <div class="content-div3">
            <div class="content-title3">流程管理</div>
            <div class="content-desc3">对流程进行管理，优化作业流程，提升效率，确保质量，实现持续改进。</div>
          </div>
        </div>
        <div class="content-title1" id="level3">
          <img src="../assets/img/allProduct/div3.png">
          智能服务
        </div>
        <div class="content-title2" id="level3-1">
          OCR能力平台
        </div>
        <div class="content-div2">
          <div class="content-div3">
            <div class="content-title3">文字识别</div>
            <div class="content-desc3">高效识别图像中的文字信息，转换为可编辑文本，助力文档数字化与智能化处理。</div>
          </div>
          <div class="content-div3">
            <div class="content-title3">表格识别</div>
            <div class="content-desc3">精确识别图片中的表格结构，转换为可编辑的电子表格，简化数据录入与分析流程。</div>
          </div>
          <div class="content-div3">
            <div class="content-title3">印章识别</div>
            <div class="content-desc3">智能识别文档中的印章图像，验证其真伪，保障文件的安全性与合规性。</div>
          </div>
        </div>
        <div class="content-div2">
          <div class="content-div3">
            <div class="content-title3">板式还原</div>
            <div class="content-desc3">准确还原文档的原始板式布局，保持排版美观与一致性，提升文档处理的效率与质量。</div>
          </div>
        </div>
        <div class="content-title2" id="level3-2">
          智能问答
        </div>
        <div class="content-div2">
          <div class="content-div3">
            <div class="content-title3">自然语言处理</div>
            <div class="content-desc3">解析、理解和生成人类语言的技术，实现人机交互的智能化，提升信息处理的效率与准确性。</div>
          </div>
          <div class="content-div3">
            <div class="content-title3">问答系统</div>
            <div class="content-desc3">基于自然语言处理技术，智能回答用户问题，提供便捷的信息查询与知识获取途径。</div>
          </div>
          <div class="content-div3">
            <div class="content-title3">机器学习</div>
            <div class="content-desc3">通过数据训练模型，使计算机能够自动学习和改进，实现智能化决策与预测，推动人工智能的发展。</div>
          </div>
        </div>
        <div class="content-title2" id="level3-3">
          知识图谱引擎
        </div>
        <div class="content-div2">
          <div class="content-div3">
            <div class="content-title3">知识推理查询</div>
            <div class="content-desc3">通过逻辑推理和知识库查询，提供精确、深入的知识解答，满足复杂查询需求。</div>
          </div>
          <div class="content-div3">
            <div class="content-title3">智能推荐</div>
            <div class="content-desc3">根据用户行为和偏好，智能推荐相关内容，提供个性化的服务体验。</div>
          </div>
          <div class="content-div3">
            <div class="content-title3">智能检索</div>
            <div class="content-desc3">利用自然语言处理和机器学习技术，快速、准确地检索信息，提高检索效率和准确性。</div>
          </div>
        </div>
        <div class="content-title2" id="level3-4">
          低代码专有大模型
        </div>
        <div class="content-div2">
          <div class="content-div3">
            <div class="content-title3">智能创建模块</div>
            <div class="content-desc3">自动化生成定制化功能模块，提升开发效率，降低错误率。</div>
          </div>
          <div class="content-div3">
            <div class="content-title3">智能创建数据模型</div>
            <div class="content-desc3">根据业务需求，智能构建数据模型，简化数据库设计过程。</div>
          </div>
          <div class="content-div3">
            <div class="content-title3">智能创建代码片段</div>
            <div class="content-desc3">基于编程规范和经验，自动生成代码片段，提高编程效率。</div>
          </div>
        </div>
        <div class="content-div2">
          <div class="content-div3">
            <div class="content-title3">智能生成表单</div>
            <div class="content-desc3">根据数据结构或业务需求，自动生成表单界面，简化界面开发流程。</div>
          </div>
        </div>
        <div class="content-title1" id="level4">
          <img src="../assets/img/allProduct/div4.png">
          关键特性
        </div>
        <div class="content-div2">
          <div class="content-div3">
            <div class="content-title3">可视化开发</div>
            <div class="content-desc3">可视化管理工具提供可视化构建能力，有效缩短研发周期。</div>
          </div>
          <div class="content-div3">
            <div class="content-title3">安全可靠</div>
            <div class="content-desc3">产品按等保、分保测评的标准建设，安全可靠。</div>
          </div>
          <div class="content-div3">
            <div class="content-title3">全面信创</div>
            <div class="content-desc3">支持国产化服务器、操作系统、中间件、数据库。</div>
          </div>
        </div>
        <div class="content-div2">
          <div class="content-div3">
            <div class="content-title3">灵活扩展</div>
            <div class="content-desc3">平台支持多种二次扩展方式，实现复杂业务需求。</div>
          </div>
          <div class="content-div3">
            <div class="content-title3">单体/微服务架构</div>
            <div class="content-desc3">双架构模式，满足用户的个性化需求。</div>
          </div>
          <div class="content-div3">
            <div class="content-title3">AI能力</div>
            <div class="content-desc3">人工智能融入到低代码开发，助力企业从数字化到数智化。</div>
          </div>
        </div>
        <div class="content-div2">
          <div class="content-div3">
            <div class="content-title3">模型/表单驱动</div>
            <div class="content-desc3">支持表单驱动和模型驱动，可以根据具体需求和开发团队的偏好选择使用。</div>
          </div>
          <div class="content-div3">
            <div class="content-title3">多模式开发</div>
            <div class="content-desc3">提供高代码、低代码、无代码三种开发模式，满足不同开发团队的不同需求。</div>
          </div>
        </div>
        <div class="content-title1" id="level5">
          <img src="../assets/img/allProduct/div5.png">
          支撑体系
        </div>
        <div class="content-div2">
          <div class="content-div3">
            <div class="content-title3">UI设计规范<img src="../assets/img/allProduct/new-img.png"></div>
            <div class="content-desc3">用于指导设计师创建一致、易用和高质量的用户界面。</div>
          </div>
          <div class="content-div3">
            <div class="content-title3">交付能力<img src="../assets/img/allProduct/new-img.png"></div>
            <div class="content-desc3">团队拥有卓越的交付能力，确保项目按时高质量完成。</div>
          </div>
          <div class="content-div3">
            <div class="content-title3">定制化服务<img src="../assets/img/allProduct/new-img.png"></div>
            <div class="content-desc3">供定制化服务，满足您的个性化需求，为您创造独特而富有价值的解决方案。</div>
          </div>
        </div>
      </div>
    </div>
    <!-- footer -->
    <ContactExperts></ContactExperts>
    <FhBottom/>
    <!-- 右侧联系方式 -->
    <SideBar @openForm="openForm"></SideBar>
    <!-- 表单 -->
    <HussarForm v-show="showForm" @closeForm="closeForm"></HussarForm>
    <!-- 返回顶部 -->
    <img src="../assets/img/homePage/top.png" class="back-top" @click="backTop" v-if="isPageScroll">
  </div>
</template>

<script>
import HussarForm from './include/HussarForm.vue';
import SideBar from './include/SideBar.vue';
import Header from './include/Header.vue';
import ContactExperts from './include/ContactExperts.vue';

export default {
  name: "KeyFeatures",
  data() {
    return {
      headColor:"dark",
      isPageScroll: false,
      showForm: false,
      isSubmit: false
    };
  },
  components: {
    Header,
    HussarForm,
    SideBar,
    ContactExperts
  },
  methods: {
    clickRolling(id){
      let targetbox= document.getElementById(id);
      let target= targetbox.offsetTop-100;
      $('html ,body').animate({scrollTop: target}, 700);
    },
    // 跳转页面
    jumpTo(page) {
      const self = this;
      self.$router.push({ path: page });
    },
    changeBg(n) {
      const self = this;
      self.caseBgIndex = n;
    },
    openForm() {
      const self = this;
      self.showForm = true;
    },
    closeForm() {
      const self = this;
      self.showForm = false;
    },
    toLink() {
      window.open("http://www.jxdinfo.com");
    },
    // 返回顶部
    backTop() {
      $('html ,body').animate({scrollTop: 0}, 700);
    },
    // 页面滚动
    handleNavScroll() {
      const self = this;
      self.isPageScroll = false;
      const scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
      if (scrollTop > 80) {
        self.isPageScroll = true;
      }
      var nav = document.querySelector('#navigation-div');
      var content = document.querySelector('#content-div');
      if(scrollTop > 3700){
        var changeScrollTop = 3800-scrollTop;
        nav.setAttribute('style', 'position: fixed;top: ' + changeScrollTop +'px')
        content.setAttribute('style', 'margin-left: 250px')
      } else if (scrollTop > 300) {
        nav.setAttribute('style', 'position: fixed;top: 100px')
        content.setAttribute('style', 'margin-left: 250px')
      }else {
        nav.setAttribute('style', '')
        content.setAttribute('style', '')
      }
    },
  },
  mounted() {
    window.addEventListener('scroll', this.handleNavScroll);
    var ua = navigator.userAgent,
      isWindowsPhone = /(?:Windows Phone)/.test(ua),
      isSymbian = /(?:SymbianOS)/.test(ua) || isWindowsPhone,
      isAndroid = /(?:Android)/.test(ua),
      isFireFox = /(?:Firefox)/.test(ua),
      isChrome = /(?:Chrome|CriOS)/.test(ua),
      isTablet = /(?:iPad|PlayBook)/.test(ua) || (isAndroid &&       !/(?:Mobile)/.test(ua)) || (isFireFox && /(?:Tablet)/.test(ua)),
      isPhone = /(?:iPhone)/.test(ua) && !isTablet,
      isPc = !isPhone && !isAndroid && !isSymbian;
    var os = {
      isTablet: isTablet,
      isPhone: isPhone,
      isAndroid: isAndroid,
      isPc: isPc
    };
    if (os.isAndroid || os.isPhone) {
      this.$router.replace({ path: '/allproductphone' });
    }
  }
};
</script>

<style scoped>
.home {color: #2E2E2E;}
.home >>> .header-con > div a{height: 100%;display: flex;align-items:center;color: #2e2e2e;}
.home >>> .navigator > div a:hover,.navigator .isActive {color: #186CF5;}
.more-btn {position: relative;left: 50%;transform: translateX(-50%);width: 120px;height: 42px;background: #186CF5;border-radius: 5px;font-size: 16px;text-align: center;color: #FFF;line-height: 42px;cursor: pointer;}
.more-btn:hover {background: rgba(21, 132, 243, 0.9);}
.value-btn {position: relative;left: 50%;transform: translateX(-50%);width: 110px;height: 38px;background: #FFF;border-radius: 5px;font-size: 16px;text-align: center;color: #186CF5;line-height: 38px;cursor: pointer;}
.value-btn:hover {background: rgba(255, 255, 255, 0.9);}

.banner{background: url("../assets/img/allProduct/banner-bg.png") no-repeat;background-size: 100% 100%;height: 460px;padding-top: 100px}
.banner-div{width: 1200px;margin:auto;color: #2e2e2e}
.banner-title{font-size: 50px;text-align: center;font-weight: bold;margin: 50px 0px 65px 0px}
.banner-desc{font-size: 14px;width: 1100px;line-height: 28px;margin: auto;text-align: justify;letter-spacing: 1px;}

.content{width: 1200px;margin: auto;display: flex;padding-top: 35px;color: #2e2e2e;margin-bottom: 100px}
.navigation-div{width: 350px;}
.nav-level1{font-size: 16px;margin: 18px 0px;cursor: pointer}
.nav-level1 img{position: relative;top: 3px;margin-right: 5px;}
.nav-level2{font-size:14px;border-left: 2px solid #E1E1E1;margin-left: 10px;line-height: 35px;padding-left: 25px;cursor: pointer}

.content-title1{font-size: 22px;margin: 20px 0px}
.content-title1 img{margin-right: 5px;position: relative;top: 4px}
.content-title2{font-size: 18px;color:#186CF5;margin:15px 0px 10px 35px;font-weight: bold;}
.content-div2{display: flex;margin-left: 25px}
.content-div3{border: 1px solid #E8E8E8;padding: 15px 20px;width: 290px;margin: 10px;cursor: pointer}
.content-div3:hover{border: 1px dashed #dddddd;box-shadow: 2px 2px 5px #EEEEEE;background: url("../assets/img/allProduct/hover-img.png") no-repeat;background-position: right bottom;}
.content-div3:hover .content-title3{color: #186CF5}
.content-title3{font-size: 16px;margin-bottom: 10px}
.content-title3 img{margin-left: 7px}
.content-desc3{font-size: 14px;color: #707070;text-align: justify;line-height: 21px}

/* 返回顶部 */
.back-top {position: fixed;top: calc(40% + 250px);right: 5px;cursor: pointer;}
/*取消页面光标*/
.model-box div,img{caret-color: transparent;}
</style>



// WEBPACK FOOTER //
// src/components/AllProduct.vue